import { render, staticRenderFns } from "./ChatFooter.vue?vue&type=template&id=3a175b0c&"
import script from "./ChatFooter.vue?vue&type=script&lang=ts&"
export * from "./ChatFooter.vue?vue&type=script&lang=ts&"
import style0 from "./ChatFooter.vue?vue&type=style&index=0&id=3a175b0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports